module.exports = __webpack_public_path__ + "static/media/close.a561c2d0.svg";